import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import { space } from 'styled-system';
import { FiChevronDown } from 'react-icons/fi';
import theme from 'styled-theming';
import { Subtitle, Title } from '../index';
import Row from '../Row';

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
});

const textColor = theme('mode', {
  light: '#AAAAAA',
  dark: '#7B7E92',
});

const Icon = styled(FiChevronDown)`
  ${space}
  stroke-width: 2px;
  color: ${iconColor};
  cursor: pointer;
  transform: scaleY(${(props) => (props.flipped === 'true' ? 1 : -1)});
  margin-right: 13px;
`;

const sectionStyle = { marginLeft: '38px' };

const Text = styled(Flex)`
color: ${textColor};
fontSize: 13px;
`;

function SdeSection(props) {
  const {
    name, description, resultList, themeMode, isOpenDefault, auth, unauth, ...otherProps
  } = props;
  const [isOpen, setIsOpen] = useState(isOpenDefault);

  const toggleSection = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <Box>
      <Flex>
        <Title
          fontSize={2}
          fontWeight={400}
          mb={0}
          clickable
          {...otherProps}
          onClick={() => toggleSection()}
        >
          <Icon
            size={18}
            flipped={isOpen.toString()}
            ml={2}
          />
          {name}
          {auth ? ' [Auth]' : null}
          {unauth ? ' [Unauth]' : null}
        </Title>
      </Flex>
      <Subtitle mt={2} mb={2} style={sectionStyle}>{description}</Subtitle>
      {
      (isOpen && resultList)
      && (
      <table style={sectionStyle}>
        <thead>
          <tr>
            <th>
              <Text>
                <Row
                  themeMode={themeMode}
                  key="DATA THAT WILL BE RETRIEVED"
                  data={{ name: 'DATA THAT WILL BE RETRIEVED' }}
                  rowType="list"
                  fontSize={1}
                  isLast
                />
              </Text>
            </th>
            <th>
              <Text>
                <Row
                  themeMode={themeMode}
                  key="ATTRIBUTE NAME"
                  data={{ name: 'ATTRIBUTE NAME' }}
                  rowType="list"
                  fontSize={1}
                  isLast
                />
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {
          resultList.map((context) => (
            <tr key={context.attribute}>
              <td>
                <Row
                  themeMode={themeMode}
                  key={context.description}
                  data={{ name: context.description }}
                  fontSize={2}
                  rowType="list"
                />
              </td>
              <td>
                <Row
                  themeMode={themeMode}
                  key={context.attribute}
                  data={{ name: context.attribute }}
                  rowType="list"
                  fontSize={2}
                  enableCopy
                />
              </td>
            </tr>
          ))
        }
        </tbody>
      </table>
      )
      }
    </Box>
  );
}

SdeSection.defaultProps = {
  name: undefined,
};

SdeSection.propTypes = {
  description: PropTypes.string.isRequired,
  name: PropTypes.string,
  resultList: PropTypes.array.isRequired,
  themeMode: PropTypes.string.isRequired,
  isOpenDefault: PropTypes.bool.isRequired,
  auth: PropTypes.bool.isRequired,
  unauth: PropTypes.bool.isRequired,
};

export default SdeSection;
